export default "__VITE_ASSET__6b0fa8bd__"